import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { collection, doc, setDoc,getDoc,getDocs,updateDoc,arrayUnion,GeoPoint,onSnapshot,query,where,addDoc } from "firebase/firestore"; 
import{GoogleAuthProvider,getAuth,signInWithPopup,signInWithEmailAndPassword,createUserWithEmailAndPassword,sendPasswordResetEmail,signOut} from 'firebase/auth';
const googleProvider = new GoogleAuthProvider();

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app)


const db = getFirestore(app);

export {db,collection,doc,setDoc,getDoc,getDocs,updateDoc,arrayUnion, GeoPoint,onSnapshot,GoogleAuthProvider,getAuth,signInWithPopup,signInWithEmailAndPassword,createUserWithEmailAndPassword,sendPasswordResetEmail,signOut,auth,googleProvider,getFirestore,query,where,addDoc}